import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@environments/environment';
import { SopResponseDto } from '@qc/shared';
import { CreateSopRequestDto, UpdateSopRequestDto } from '@qc/shared';

@Injectable({
    providedIn: 'root',
})
export class SopService {
    private http = inject(HttpClient);
    private apiUrl = `${APP_CONFIG.apiUrl}/sops`;

    getAllSops(): Observable<SopResponseDto[]> {
        return this.http.get<SopResponseDto[]>(this.apiUrl);
    }

    getSopById(id: string): Observable<SopResponseDto> {
        return this.http.get<SopResponseDto>(`${this.apiUrl}/${id}`);
    }

    createSop(createSopDto: CreateSopRequestDto): Observable<SopResponseDto> {
        return this.http.post<SopResponseDto>(this.apiUrl, createSopDto);
    }

    updateSop(id: string, updateSopDto: UpdateSopRequestDto): Observable<SopResponseDto> {
        return this.http.patch<SopResponseDto>(`${this.apiUrl}/${id}`, updateSopDto);
    }

    deleteSop(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }

    getSopsByWarehouseDetailId(warehouseDetailId: string): Observable<SopResponseDto[]> {
        return this.http.get<SopResponseDto[]>(`${this.apiUrl}?warehouseDetailId=${warehouseDetailId}`);
    }
}
